import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { BsArrowRight } from 'react-icons/bs';


function TimelineItem({ year, icon, heading, text, transform, image }) {
    const [isModalOpen, setModalOpen] = useState(false);

    const wordLimit = 20;
    const words = text.trim().split(/\s+/);
    const isLongText = words.length > wordLimit;
    const previewText = isLongText ? words.slice(0, wordLimit).join(' ') + '...' : text;

    const modalContent = isModalOpen && ReactDOM.createPortal(
        <div className="custom-modal-overlay" onClick={() => setModalOpen(false)}>
            <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
                <h4>{year} - {heading}</h4>
                <p>{text}</p>
                <button onClick={() => setModalOpen(false)} className="timeline-modal-close-btn important-btn-padding">
                    Close
                </button>
            </div>
        </div>,
        document.body
    );

    return (
        <>
            <div className={`single-time-line ${transform}`}>
                <h2>{year}</h2>
                <div className="timeline-img">
                    <img src={image} alt={heading} />
                </div>
                <div className="content">
                    <h4>{heading}</h4>
                    {/* <p>{previewText}</p> */}
                    {true && (
                        <button onClick={() => setModalOpen(true)} className="read-more-btn">
                            read more <BsArrowRight />
                        </button>
                    )}
                    {/* {isLongText && (
                        <button onClick={() => setModalOpen(true)} className="read-more-btn">
                            read more <BsArrowRight />
                        </button>
                    )} */}
                </div>
            </div>

            {modalContent}
        </>
    );
}

export default TimelineItem;
